import { EtiquetasGenerales_EN } from './Genericos/EtiquetasGenerales_EN';

const EtiquetasModulo = {
    NombrePortal: {
        Et_Nombre: "New Admission Portal"
    },
    Home: {
        Et_lblHola: 'Hello',
        Et_lblSaludosDia: 'Welcome to the new admission portal',
        Et_lblDescripcion: 'Don\'t let your goals stop, start your academic project and make your dreams come true.',
        Et_lblRegistro: 'Registration',
        Et_lblAdmision: 'Admission',
        Et_lblDatosPersonales: 'Personal Information',
        Et_lblContactos: 'Contacts',
        Et_lblSeleccion: 'Selection',
        Et_lblRequisitosAdmision: 'Admission Requirements',
        Et_lblCodigoVerificacion: 'Verification Code',
        Et_lblCodigoVerificacionDescripcion: 'Please enter your corresponding verification code.',
        Et_lblAdmisionProgramas: 'Programs',
        Et_lblAdmisionPlanes: 'Plans by Program',
        Et_lblDocumento: 'Document',
        Et_lblAdjuntar: 'Attach',
        Et_lblObtenerCodigo: 'Resend verification code',
        Et_lblAdjuntosPendientes: 'There are pending admission requirements to attach to the requested documentation.',
        Et_lblEnviarAdmisionMsg: "We have received your admission application. The institution's staff will validate the documentation and you will receive an email with the next steps. Thank you for choosing our institution!",
        Et_lblOrigen: 'Origin',
        Et_InformacionAdicional: 'Additional Information',
        Et_lblcomenzar:'Start'
    },
    InterfazDatosPersonales: {
        Et_TituloPrincipal: 'Personal Information',
        Et_tblCusTipoCIF: 'CIF Type',
        Et_tblCusTypeIdeFk: 'Identification Type',
        Et_tblCusTypeIdeFkShort: 'ID Type',
        Et_tblcusFullName: 'Full Name',
        Et_tblCusLastName1: 'First Surname',
        Et_tblCusLastName2: 'Second Surname',
        Et_tblFechaNacimiento: 'Date of Birth',
        Et_tblCusCivilStatusFkShort: 'Civil Status',
        Et_tblCusCivilStatusFk: 'Civil Status',
        Et_tblCusGenderFk: 'Gender',
        Et_tblValidIdeMinimo: "The ID number has fewer digits ({0}) than allowed for the selected identification type ({1}).",
        Et_tblValidIdeMaximo: "The ID number has more digits ({0}) than allowed for the selected identification type ({1}).",
        Et_tblValidIdeFormato: "The ID number is not in the required format for the selected identification type. {0}",
        Et_tblIdeFormato: "Valid format: {0}.",
    },
    InterfazClienteContactInfo: {
        Et_tblAddress: 'Addresses',
        Et_tblAddressType: 'Address Type',
        Et_tblCountry: 'Country',
        Et_tblProvince: 'Province',
        Et_tblCanton: 'Canton',
        Et_tblDistrict: 'District',
        Et_tblNeighborhood: 'Neighborhood',
        Et_tblExactAdress: 'Exact Address',
        Et_tblPostalCode: 'Postal Code',
        Et_tblContact: 'Phones',
        Et_tblPhoneType: 'Phone Type',
        Et_tblPhone: 'Phone',
        Et_tblCountryCode: 'Country Code',
        Et_SelecAddTy: 'Select the address type',
        Et_SelecContactTyp: 'Select the contact type',
        Et_SelecEmailTyp: 'Select the email type',
        Et_tblEmailTittle: 'Email',
        Et_tblEmailType: 'Email Type',
        Et_tblEmail: 'Email',
    },
    PlantillaCorreoToken: {
        Et_Hola: 'Hello ',
        Et_TextoSuCodigo: 'Your verification code is: ',
        Et_Gracias: 'Thank you for using our portal.',
        Et_Asunto: 'Verification Code'
    },
    InterfazNacionalidad: {
        Et_tblCountrys: "Nationalities",
        Et_tblCIFs: "CIF Types",
        Et_SelecCIFs: "CIF Type",
        Et_tblCIF: "CIF Type",
        Et_SelecCountry: "Country",
        Et_SelecTypeCountry: "Nationality Type",
        Et_tblCountry: "Country",
        Et_tblTypeCountry: "Nationality Type",
        Et_tblNacionalidad: "National",
        Et_tblRecidencia: "Residence",
    }
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_EN, ...EtiquetasModulo };

const Etiquetas_En = {
    Idioma: "EN",
    Etiquetas: EtiquetasUnificadas
};

export default Etiquetas_En;
